export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_03.af912969.png";